'use client'

import { Builder } from '@builder.io/react'

import { ButtonVariants } from '@src/components/Button/Button'

import { SKUSelector } from './SKUSelector'
import { SKUSelectorDefaults } from './SKUSelector.defaults'

Builder.registerComponent(SKUSelector, {
  name: 'SKUSelector',
  inputs: [
    {
      name: 'previewAllItems',
      type: 'boolean',
      defaultValue: SKUSelectorDefaults.previewAllItems,
    },
    {
      name: 'options',
      type: 'list',
      defaultValue: SKUSelectorDefaults.options,
      subFields: [
        {
          name: 'isDropdown',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'sku',
          type: 'text',
          localized: true,
          showIf: 'options.get("isDropdown") !== true',
        },
        {
          name: 'content',
          type: 'blocks',
          localized: true,
          hideFromUI: true,
          defaultValue: SKUSelectorDefaults.options[1].content,
        },
        {
          name: 'dropdownOptions',
          showIf: 'options.get("isDropdown") === true',
          type: 'list',
          defaultValue: SKUSelectorDefaults.options[0].dropdownOptions,
          subFields: [
            {
              name: 'sku',
              type: 'text',
              localized: true,
            },
            {
              name: 'label',
              type: 'text',
              localized: true,
              defaultValue: SKUSelectorDefaults.options[0].dropdownOptions?.[0].label,
            },
            {
              name: 'content',
              type: 'blocks',
              localized: true,
              hideFromUI: true,
              defaultValue: SKUSelectorDefaults.options[0].dropdownOptions?.[0].content,
            },
          ],
        },
      ],
    },
    {
      name: 'addToCartContent',
      type: 'blocks',
      hideFromUI: true,
      defaultValue: SKUSelectorDefaults.addToCartContent,
    },
    {
      name: 'addToCartVariant',
      type: 'string',
      enum: ButtonVariants,
      defaultValue: SKUSelectorDefaults.addToCartVariant,
      friendlyName: 'CTA Color Variant',
    },
    {
      name: 'redirectUrl',
      type: 'text',
      localized: true,
      defaultValue: SKUSelectorDefaults.redirectUrl,
    },
  ],
})
